import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    src: string;
    alt?: string;
    className?: string;
}

const ContactSourceIcon = ({ src, alt, className }: Props) => (
    <img
        className={twMerge(
            'flex size-4 items-center justify-center rounded-sm bg-gray-200 text-xs text-gray-500',
            className,
        )}
        src={src}
        alt={alt}
    />
);

export default ContactSourceIcon;
